import { render, staticRenderFns } from "./CreateTeamTargetForm.vue?vue&type=template&id=6469b205&"
import script from "./CreateTeamTargetForm.vue?vue&type=script&lang=ts&"
export * from "./CreateTeamTargetForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateTeamTargetForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports